import React, { Component } from "react";
import { http, baseURL } from "../misc/http";
import defautlPicture from "../assets/default.jpg";
import Layout from "../layout/Main";
import Content from "../components/EventDetil/Content";
import FormRegister from "../components/EventDetil/FormRegister";
import ModalMessage from "../components/EventDetil/ModalMessage";
import validate from "validator";
import validator from "validator";
export default class EventDetil extends Component {
  state = {
    isLogin: false,
    showForm: false,
    showModal: false,
    event: {},
    textMessage: "",
    participants: [
      {
        name: "",
        phone: "",
        email: "",
        institute: ""
      }
    ],
    quantity: 1,
    isValid: false,
    //
    collapse: "",
    listGuide: []
  };

  getLocalData = async () => {
    let user = JSON.parse(localStorage.getItem("kominfo-psre"));
    this.setState({ user: user, isLogin: user !== null ? true : false });
  };

  handleGetGuide = async (category = "") => {
    let params = {
      method: "GET",
      path: "regulation",
      showMessage: false
    };
    let { data } = await http(params);
    console.log(data);
    if (data.code === 200) {
      let { listGuide } = this.state;
      if (data && data.status) {
        console.log("jalan");
        data.data.forEach(e => {
          if (e.regulationFile) e.regulationFile = baseURL + e.regulationFile;
          if (e.type === "regulation") listGuide.push(e);
        });
        this.setState({ listGuide });
      }
    }
  };

  handleCollapse = collapse => {
    if (collapse === this.state.collapse) collapse = "";
    this.setState({ collapse });
  };

  componentDidMount = async () => {
    console.log(this.props);
    let { id } = this.props.match.params;
    await this.handleGetGuide();
    await this.getEventById(id);
    await this.getLocalData();
  };

  getEventById = async id => {
    let params = {
      method: "GET",
      path: "events/" + id,
      showMessage: false
    };
    let { data } = await http(params);
    if (data.status === true && data.code === 200) {
      let { event } = this.state;
      event = data.data;
      this.setState({ event });
    }
  };

  handleShowForm = () => {
    if (this.state.isLogin) {
      let newForm = [
        {
          name: "",
          phone: "",
          email: "",
          institute: ""
        }
      ];
      this.setState({
        showForm: true,
        participants: newForm,
        quantity: 1
      });
    } else {
      this.setState({
        textMessage: "Silahkan login terlebih dahulu",
        showForm: true
      });
    }
  };

  handleCloseForm = () => {
    this.setState({ showForm: false });
  };

  handleRegister = async () => {
    let params = {
      method: "POST",
      // path: "events/join/" + this.state.event._id,
      path: "events/joinWebinar/" + this.state.event._id,
      data: {
        quantity: this.state.quantity,
        participantData: this.state.participants
      },
      showMessage: false
    };
    let { data } = await http(params);
    this.setState({
      showModal: true,
      showForm: false,
      textMessage: data.message
    });
    // this.handleCloseForm();
  };

  handleCloseModal = () => {
    this.setState({ showModal: false });
  };

  handleAddQuantity = async ({ target: { value } }) => {
    let newParticipants = this.state.participants;
    if (value === "1" && this.state.participants.length === 2)
      newParticipants.pop();
    else
      newParticipants.push({
        name: "",
        phone: "",
        email: "",
        institute: ""
      });
    await this.setState({ participants: newParticipants, quantity: value });
    this.validateForm();
  };

  handleOnChange = async ({ target: { name, value } }) => {
    let newParticipants = [...this.state.participants];
    let index = Number(name.substr(name.length - 1, 1)) - 1;
    let newName = name.substring(0, name.length - 1);
    newParticipants[index][newName] = value;
    await this.setState({ participants: newParticipants });
    this.validateForm();
  };

  validateForm = () => {
    let participants = this.state.participants;
    let valid = true;
    let counter = 1;
    while (valid && counter <= participants.length) {
      if (
        !validator.matches(participants[counter - 1].name, /[a-z, A-Z, \s]/) ||
        participants[counter - 1].name.length < 3
      )
        valid = false;
      if (!validator.isMobilePhone(participants[counter - 1].phone))
        valid = false;
      if (!validator.isEmail(participants[counter - 1].email)) valid = false;
      if (
        !validator.matches(
          participants[counter - 1].institute,
          /[a-z, A-Z, \s]/
        ) ||
        participants[counter - 1].institute.length < 3
      )
        valid = false;
      counter++;
    }
    this.setState({ isValid: valid });
  };

  render() {
    return (
      <Layout>
        <section class="header-apa-psre">
          <img
            src={
              this.state.event.picture
                ? baseURL + "/" + this.state.event.picture
                : defautlPicture
            }
            alt="acara"
            style={{ width: "100%", height: "200px", objectFit: "cover" }}
          />
        </section>
        <Content
          url={this.props.history.location.pathname}
          idEvent={this.props.match.params.id}
          handleShowForm={this.handleShowForm}
          collapse={this.state.collapse}
          listGuide={this.state.listGuide}
          handleCollapse={this.handleCollapse}
          event={this.state.event}
          baseURL={baseURL}
          isLogin={this.state.isLogin}
        />
        <FormRegister
          event={this.state.event}
          showForm={this.state.showForm}
          handleCloseForm={this.handleCloseForm}
          handleRegister={this.handleRegister}
          handleAddQuantity={this.handleAddQuantity}
          participants={this.state.participants}
          handleOnChange={this.handleOnChange}
          quantity={this.state.quantity}
          isValid={this.state.isValid}
        />
        <ModalMessage
          showModal={this.state.showModal}
          handleCloseModal={this.handleCloseModal}
          handleCloseForm={this.handleCloseForm}
          event={this.state.event}
          textMessage={this.state.textMessage}
        />
      </Layout>
    );
  }
}
